import { render, staticRenderFns } from "./PurchasesTable.vue?vue&type=template&id=41ab6f6f&scoped=true&"
import script from "./PurchasesTable.vue?vue&type=script&lang=js&"
export * from "./PurchasesTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesTable.vue?vue&type=style&index=0&id=41ab6f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ab6f6f",
  null
  
)

export default component.exports